import styled from "styled-components";

export const EditedBoxSC = styled.div`
  border: 1px dashed #ccc;
  padding: 5px;
  border-radius: 4px;
  background-color: #fff;
  line-height: 2;
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;
`;

export const WordsBoxSC = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 5px;
`;

export const ButtonWrapperSC = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
